<template>
    <section v-if="libraries.length">
        <div>
            <b-autocomplete
                ref="listRef"
                v-model="filter"
                :disabled="disabled"
                :clear-on-select="false"
                placeholder="Search for a library to select it"
                :keep-first="false"
                :open-on-focus="true"
                :loading="loading"
                :data="filteredRefs"
                icon-right="chevron-down"
                clearable
                @typing="handleTyping"
                @select="handleSelect">
                <template #default="slotProps">
                    <div class="media">
                        <div
                            class="media-content">
                            <b>{{ slotProps.option }}</b>
                        </div>
                    </div>
                </template>
            </b-autocomplete>
        </div>
    </section>
</template>

<script lang="ts" setup>
    import { getLibraryNames } from '@/shared/helpers/api.js';
    import { http } from '@/shared/httpWrapper';
    import { computed, onMounted, ref, watch } from 'vue';

    const props = withDefaults(defineProps<{
        selected?: string;
        loading?: boolean;
        disabled?: boolean;
        existingLibraries?: string[];
    }>(), {
        selected: '',
        loading: false,
        disabled: false,
        existingLibraries: () => []
    });

    const emit = defineEmits<{
        libSelected: [payload: string];
    }>();

    const filter = ref<string>('');
    const newSelected = ref<string | null>(null);
    const libraries = ref<string[]>([]);

    const filteredRefs = computed(() => {
        const search = filter.value?.toLowerCase();
        return libraries.value
            .filter(lib => search === null || lib.toLowerCase().includes(search))
            .filter(lib => !props.existingLibraries.includes(lib))
            .sort((a, b) => a.localeCompare(b))
            .slice(0, 100);
    });

    watch(() => props.selected, (value: string) => {
        setValue(value);
    });

    onMounted(async () => {
        libraries.value = await getLibraryNames(http);

        if (libraries.value.length && props.selected && props.selected.length) {
            setValue(props.selected);
        }
    });

    function setValue(value: string) {
        newSelected.value = value;
        filter.value = value ?? '';
    }

    function handleSelect(option: string) {
        newSelected.value = option;
        filter.value = option;
        emit('libSelected', newSelected.value ?? '');
    }

    function handleTyping(input: string) {
        filter.value = input;
    }
</script>
